import styled from 'styled-components'
import { Form } from 'antd'
import { SPACING, BORDER_RADIUS, TYPOGRAPHY, FONT_WEIGHT } from '../../../styles/theme'

/**
 * Styled components for ChangeEmailForm
 */

export const FormContainer = styled.div`
  max-width: 100%;
`

export const CurrentEmailDisplay = styled.div`
  margin-bottom: ${SPACING.xl};
`

export const EmailLabel = styled.div`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.medium};
  color: var(--color-text-secondary);
  margin-bottom: ${SPACING.xs};
`

export const EmailValue = styled.div`
  font-size: ${TYPOGRAPHY.body.fontSize};
  color: var(--color-text-primary);
  background: var(--color-bg-secondary);
  padding: ${SPACING.md} ${SPACING.lg};
  border-radius: ${BORDER_RADIUS.lg};
  border: 1px solid var(--color-border);
`

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: ${SPACING.lg};

  .ant-form-item-label > label {
    font-weight: ${FONT_WEIGHT.medium};
    color: var(--color-text-secondary);
    font-size: ${TYPOGRAPHY.caption.fontSize};
  }
`

export const FormActions = styled.div`
  display: flex;
  justify-content: flex-start;
  padding-top: ${SPACING.sm};
`
